import React, { useState, useEffect } from "react";
import { Checkbox, Icon } from "semantic-ui-react";

const DefaultTabSelector = ({ currentTab, onSetDefault }) => {
  // Track the default tab in component state
  const [isDefault, setIsDefault] = useState(
    localStorage.getItem("defaultTab") === currentTab
  );

  // Update the state when localStorage changes or currentTab changes
  useEffect(() => {
    setIsDefault(localStorage.getItem("defaultTab") === currentTab);
  }, [currentTab]);

  if (isDefault) {
    return (
      <span
        style={{ fontStyle: "italic", color: "green" }}
        title={"This tab is your default"}
      >
        <Icon name="check" /> Default tab
      </span>
    );
  } else {
    return (
      <Checkbox
        label="Default tab"
        checked={isDefault}
        onChange={() => {
          if (!isDefault) {
            onSetDefault(currentTab);
            // Immediately update local state to avoid waiting for the next render
            setIsDefault(true);
          }
        }}
        title="Set this tab as your default"
      />
    );
  }
};

export default DefaultTabSelector;
